import { CacheEntry } from '../types/CacheEntry';

export const isCacheStale = (
  entry: CacheEntry | null | undefined,
  ttl: number,
  now: number = Date.now(),
) => Boolean(entry && now - entry.timestamp > ttl);
